import { MoreVertRounded } from "@mui/icons-material";

export const more = (props) => {
  return <MoreVertRounded {...props} />;
};
